import { Injectable } from '@angular/core';
import { BaseRepository } from '../Common/Data/base.repository';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AccountService, UserData } from '../User/account.service';

@Injectable(
    { providedIn: 'root' }
)
export class AuthenticationService extends BaseRepository {
    constructor(httpClient: HttpClient, private _accountService: AccountService) {
        super(httpClient);
    }
    
    async getUserInfo(): Promise<UserData> {
        const userViewModel = await lastValueFrom(this.httpGet('/api/account/GetUserInfo')) as UserData;
        console.log(userViewModel)
        this._accountService.ensureUserHasAccessToPriorInstanceSelection(userViewModel);
        return userViewModel
    }
}